import $ from 'jquery';

export function bringModalToFront(
  selector,
  { onModalDismissed = () => {}, onModalShown = () => {} } = {}
) {
  const modalWindow = $(selector);

  modalWindow.on('hidden.bs.modal', function handleModalDismissed() {
    modalWindow.css({ zIndex: '' });
    modalWindow.off('hidden.bs.modal', handleModalDismissed);

    onModalDismissed && onModalDismissed();
  });

  modalWindow.on('show.bs.modal', function bringToFront() {
    onModalShown && onModalShown();
    modalWindow.off('show.bs.modal', bringToFront);
  });
}
